// @mui
import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
} from '@mui/material';
// components
import Iconify from '../../../components/iconify';

export type ViewType = 'list' | 'grid';

interface Props extends ToggleButtonGroupProps {
  value: string;
  onChange: (
    event: React.MouseEvent<HTMLElement>,
    newView: ViewType | null,
  ) => void;
}

export default function FileChangeViewButton({
  value,
  onChange,
  ...other
}: Props) {
  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      sx={{
        backgroundColor: (theme) => theme.palette.background.default,
        border: (theme) => `solid 1px ${theme.palette.divider}`,
        ':hover': {
          border: (theme) => `solid 1px ${theme.palette.action.active}`,
        },
      }}
      value={value}
      exclusive
      onChange={onChange}
      {...other}
    >
      <ToggleButton value="list">
        <Iconify icon="eva:list-fill" />
      </ToggleButton>

      <ToggleButton value="grid">
        <Iconify icon="eva:grid-fill" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
